import { Container, Group } from 'ui';

import { CategoryFilterCard } from './CategoryFilterCard/CategoryFilterCard';
import { OnlineSearch } from './OnlineMerchantSearch';

const OnlineOffersContent = () => {
  return (
    <Group pos="relative" align="flex-start">
      <CategoryFilterCard />

      <OnlineSearch />
    </Group>
  );
};

const EarnOnline = () => {
  return (
    <Container
      size="xl"
      style={{
        minHeight: 'calc(100vh - var(--app-shell-header-height) - var(--app-shell-padding) - 12px)',
      }}
    >
      <OnlineOffersContent />
    </Container>
  );
};

export default EarnOnline;
